import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import FormRenderer from "../forms/JsonForm/FormRenderer/FormRenderer";
import { Dialog, DialogActions, DialogTitle, DialogContent, Typography, Button, Tooltip, Chip, CircularProgress } from "@mui/material"
import moment from "moment";
import axios from 'axios';
import { APIURL } from '../../config';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { convertTime } from "src/utils/time";

const CheckoutForms = (props) => {
    const [open, setOpen] = useState(false);
    const [customerGoals, setCustomerGoals] = useState([]);
    const [claimStatus, setClaimStatus] = useState(null);
    const [claimStatusLoading, setClaimStatusLoading] = useState(false);

    useEffect(() => {
        async function fetchData() {
            const response = (await axios.get(APIURL + `/customer_goal/getCustomerGoalsByTaskType`, {
                params: { customer_id: props.customer_id, task_id: props.task_id }
            })).data;
            setCustomerGoals(response);
        }

        if (props.customer_id && props.task_id) {
            fetchData();
        }
    }, []);

    useEffect(() => {
        if (open && props.taskDetails?.tas_claim_id) {
            setClaimStatusLoading(true);
            axios.get(APIURL + `/claims?claim_id=${props.taskDetails.tas_claim_id}`)
                .then(res => setClaimStatus(res.data.Status))
                .catch(() => setClaimStatus(null))
                .finally(() => setClaimStatusLoading(false));
        } else {
            setClaimStatus(null);
        }
    }, [open, props.taskDetails]);

    return (
        <Box>
            {props.forms.map(form =>
                <Box
                    key={form.form_id}
                    onClick={() => {
                        props.setSelectedForm(form);
                        setOpen(true);
                    }}
                    sx={{
                        border: "1px solid black",
                        borderRadius: "5px",
                        padding: "5px",
                        margin: "5px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <Box>{form.form_name}</Box>
                    {props?.completedForms?.includes(form.form_id) ?
                        <CheckCircleOutlinedIcon /> :
                        null
                    }
                </Box>
            )}
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth='md'
                fullWidth
                scroll='body'
                disableRestoreFocus
            >
                <DialogTitle sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '16px 24px',
                    borderBottom: '1px solid #e0e0e0'
                }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {props.selectedForm?.form_name} <span style={{ fontWeight: 'normal' }}>for</span> {props.customer_name}
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{
                                textAlign: 'right',
                                marginRight: '16px',
                                paddingRight: '16px',
                                borderRight: '1px solid #e0e0e0'
                            }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                                    {props?.taskDetails?.tas_title}
                                </Typography>
                                {console.log(props.taskDetails, '>>>>>')}
                                <Typography variant="body2" color="text.secondary">
                                    {convertTime(props?.taskDetails?.tas_start_time, props?.taskDetails?.task_emp_timezone, moment.tz.guess(), 'MM/DD/YYYY hh:mm A') ?? moment(props?.taskDetails?.tas_start_time).format('MM/DD/YYYY hh:mm A')}
                                    {" - "}
                                    {convertTime(props?.taskDetails?.tas_end_time, props?.taskDetails?.task_emp_timezone, moment.tz.guess(), 'MM/DD/YYYY hh:mm A') ?? moment(props?.taskDetails?.tas_end_time).format('MM/DD/YYYY hh:mm A')}
                                </Typography>
                            </Box>

                            <Tooltip
                                title={
                                    customerGoals?.length > 0 ? (
                                        <Box sx={{ maxWidth: 300 }}>
                                            {customerGoals.map((cg, index) => (
                                                <Box key={cg.customer_goal_id} sx={{ mb: index < customerGoals.length - 1 ? 2 : 0 }}>
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                                        {index + 1}. {cg.goal_title}:
                                                    </Typography>
                                                    <Typography variant="body2">{cg.goal_detail}</Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    ) : (
                                        <Typography variant="subtitle2">No goals for this customer yet.</Typography>
                                    )
                                }
                                placement="right-start"
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                        minWidth: 'unset',
                                        width: '42px',
                                        height: '42px',
                                        borderRadius: '21px',
                                        padding: 0,
                                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                        '&:hover': {
                                            backgroundColor: '#0069d9',
                                            boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                                        },
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Box sx={{
                                        display: 'flex',
                                        fontWeight: 'medium',
                                        fontSize: '14px'
                                    }}>
                                        CG
                                    </Box>
                                </Button>
                            </Tooltip>
                        </Box>
                        {props.taskDetails?.tas_claim_id && (
                            claimStatusLoading
                                ? <CircularProgress size={18} />
                                : claimStatus && (
                                    <Chip
                                        label={`Billing Status: ${claimStatus}`}
                                        size="small"
                                        color="success"
                                    />
                                )
                        )}
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {claimStatusLoading
                        ? <CircularProgress size={24} sx={{ display: 'block', margin: '16px auto' }} />
                        : <FormRenderer
                            form_id={props.selectedForm?.form_type ? props.selectedForm?.form_type : props.selectedForm?.form_id}
                            json_schema={props.selectedForm?.translated_json_schema ? props.selectedForm?.translated_json_schema : props.selectedForm?.json_schema}
                            ui_schema={props.selectedForm?.ui_schema}
                            styles={{ width: "100%", minWidth: "600px" }}
                            onSubmit={(form) => { setOpen(false); if (props.onSubmit) props.onSubmit(form); }}
                            onEdit={props.onEdit}
                            customer_id={props.customer_id}
                            task_id={props.task_id}
                            user_id={props.user_id}
                            readOnly={props.readOnly || (!!claimStatus && !['Ready to Bill', 'Rejected', 'Denied'].includes(claimStatus))}
                        />
                    }
                </DialogContent>
            </Dialog>
        </Box>
    )
}

export default CheckoutForms;